import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../../modules/shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaNumeroCadastros = () => {
    const [totalUsuarios, setTotalUsuarios] = useState('')

    const buscaNumeroCadastros = useCallback(() => {
        http.get('/nr-cadastros-totais', )
        .then(res => {
            const nrTotalCadastros = res.data
            setTotalUsuarios(nrTotalCadastros)
        })
        .catch(() => setTotalUsuarios(''))
    }, [])

    useEffect(() => {
        buscaNumeroCadastros()
    }, [buscaNumeroCadastros])

    useRecarregaAoRenovarToken(buscaNumeroCadastros)

    return {
        totalUsuarios
    }
}
